import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.15, ease: [0.25, 0.46, 0.45, 0.94] },
  }),
};

export const Philosophy = () => {
  return (
    <section data-testid="philosophy-section" className="py-24 md:py-36 bg-soft-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left — Statement */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            custom={0}
          >
            <span className="font-body text-xs uppercase tracking-[0.2em] text-charcoal/50 block mb-6">
              Philosophy
            </span>
            <h2
              data-testid="philosophy-heading"
              className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-[-0.02em] text-deep-black leading-[1.15] font-light"
            >
              We design products, brands and ranges that look{" "}
              <span className="font-medium">refined</span> and work{" "}
              <span className="font-medium">hard</span> in the real world.
            </h2>
          </motion.div>

          {/* Right — Paragraphs */}
          <div className="flex flex-col justify-end gap-8">
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={fadeUp}
              custom={1}
              data-testid="philosophy-text-1"
              className="font-body text-base text-charcoal/60 leading-relaxed font-light"
            >
              We believe great design sits at the intersection of visual taste
              and commercial intelligence. Every brand touchpoint — from
              packaging to shelf presence — should feel considered, coherent, and
              built to convert.
            </motion.p>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={fadeUp}
              custom={2}
              data-testid="philosophy-text-2"
              className="font-body text-base text-charcoal/60 leading-relaxed font-light"
            >
              Our approach combines packaging craft, brand thinking, and retail
              logic into a single, seamless process — delivering work that looks
              premium and performs commercially.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};
